import React, { useState, useEffect } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import {
    formateDateAndTime,
    httpRequestDownload,
    httpRequestGet,
    toaster
} from "../../utils/utils";
import { useDispatch } from "react-redux";
import apiConstants from "../../constans/apiConstants";
import DataTable from "../../components/Table";
import ItemSelect from "../../components/SelectItemsPerPage/SelectItemsPerPage";
import ExportExcelButton from "../../components/Table/ExportExcelButton";

const AuditTrailReport = () => {
    const [proposalNumber, setProposalNumber] = useState("");

    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    const [maxEndDate, setMaxEndDate] = useState(null);
    let maxStartDate = new Date();
    const [completeDateFlag, setCompleteDateFlag] = useState(false);

    const [data, setData] = useState({});
    const [recordsPerPage, setRecordsPerPage] = useState(20);
    const [currentPage, setCurrentPage] = useState(0);
    const dispatch = useDispatch();

    const searchData = (pageNum = currentPage) => { 
        const trimmedProposal = proposalNumber.trim();
        // if (!trimmedProposal) {
        //     toaster("error", "Please enter proposal number");
        //     return;
        // }

        let start = new Date(startDate);
        let end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            toaster("error", "Invalid date. Use the format DD-MM-YYYY HH:MM:SS");
            return;
        }

        if (end - start > 2592000000) {
            toaster("error", "Start date and end date can't be more than 30 days apart");
            return;
        }

        const param =
            "fromDate=" +
            formateDateAndTime(start) +
            "&pageNum=" +
            pageNum +
            "&pageSize=" +
            recordsPerPage +
            "&proposalNumber=" +
            encodeURIComponent(trimmedProposal) +
            "&toDate=" +
            formateDateAndTime(end);
        const path = `${apiConstants().DASHBOARD_API_URL}api/v1/tracker/fetchJourneyAudit?${param}`;
        dispatch({ type: "LOADER_TRUE" });
        httpRequestGet(path)
            .then((res) => {
                dispatch({ type: "LOADER_FALSE" });
                if (res && res.data) {
                    setData(res.data.body || {});
                    if (res.data.message) {
                        toaster("success", res.data.message);
                    }
                }
            })
            .catch((err) => {
                dispatch({ type: "LOADER_FALSE" });
                setData({});
                if (err && err.data) {
                    toaster("error", err.data.message);
                }
            });
    };

    useEffect(() => {
        if (startDate != null && endDate != null && proposalNumber.trim()) {
            searchData();
        }
    }, [currentPage, recordsPerPage]);

    useEffect(() => {
        if (startDate) {
            startDate = new Date(startDate);
            let md = new Date(startDate.setDate(startDate.getDate() + 30));
            startDate.setDate(startDate.getDate() - 30);
            setMaxEndDate({
                maxEndDate: md,
            });
        }
    }, [startDate]);

    useEffect(() => {
        if (startDate && endDate) {
            setCompleteDateFlag(true);
            endDate = new Date(endDate);
        }
    }, [endDate]);

    const selectPage = (pgNo) => {
        setCurrentPage(pgNo - 1);
    };

    const setMaxRecords = (size) => {
        setRecordsPerPage(size);
    };

    const handleApply = () => {
        if (currentPage === 0) {
            searchData(0);
        } else {
            setCurrentPage(0);
        }
    };

    const downloadReport = () => {
        const trimmedProposal = proposalNumber.trim();
        if (!trimmedProposal) {
            toaster("error", "Please enter proposal number");
            return;
        }

        let start = new Date(startDate);
        let end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            toaster("error", "Invalid date. Please use the format DD-MM-YYYY HH:MM:SS");
            return;
        }

        if (end - start > 2592000000) {
            toaster("error", "Start date and end date can't be more than 30 days apart");
            return;
        }

        const param =
            "fromDate=" +
            formateDateAndTime(start) +
            "&proposalNumber=" +
            encodeURIComponent(trimmedProposal) +
            "&toDate=" +
            formateDateAndTime(end);
        const path = `${apiConstants().DASHBOARD_API_URL}api/v1/tracker/downloadJourneyAudit?${param}`;
        dispatch({ type: "LOADER_TRUE" });
        httpRequestDownload(path)
            .then((res) => {
                dispatch({ type: "LOADER_FALSE" });
                if (res && res.data) {
                    var blob = new Blob([res.data], { type: "text/csv" });
                    var objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                }
            })
            .catch((err) => {
                dispatch({ type: "LOADER_FALSE" });
                if (err && err.data) {
                    toaster("error", err.data.message);
                }
            });
    };

    const header = [
        "Proposal Number",
        "Journey Selected",
        "Status",
        "Response Message",
        "Created On",
        "Updated On",
    ];

    const key = [
        "proposalNumber",
        "journeySelected",
        "status",
        "responseMessage",
        "createdOn",
        "updatedOn",
    ];
    return (
        <div className="policy-report">
            <div className="policy-report__panel">
                <div className="policy-report__grid">
                    <div className="policy-report__field policy-report__field--source">
                        <label
                            className="policy-report__label"
                            htmlFor="audit-proposal-number"
                        >
                            Proposal Number
                        </label>
                        <input
                            id="audit-proposal-number"
                            onChange={(e) => setProposalNumber(e.target.value)}
                            value={proposalNumber}
                            className="policy-report__input"
                            type="text"
                            placeholder="Enter proposal number"
                        />
                    </div>

                    <div className="policy-report__field">
                        <label className="policy-report__label" htmlFor="audit-start-date">
                            Start Date
                        </label>
                        <Datetime
                            inputProps={{
                                id: "audit-start-date",
                                placeholder: "DD-MM-YYYY HH:mm:ss",
                            }}
                            value={startDate}
                            onChange={(date) => setStartDate(date)}
                            isValidDate={(current) => current.isBefore(maxStartDate)}
                            dateFormat="DD-MM-YYYY"
                            timeFormat="HH:mm:ss"
                        />
                    </div>

                    <div className="policy-report__field">
                        <label className="policy-report__label" htmlFor="audit-end-date">
                            End Date
                        </label>
                        <Datetime
                            inputProps={{
                                id: "audit-end-date",
                                placeholder: "DD-MM-YYYY HH:mm:ss",
                            }}
                            disabled={!startDate}
                            value={endDate}
                            onChange={(date) => setEndDate(date)}
                            isValidDate={(current) =>
                                current.isBefore(maxEndDate?.maxEndDate)
                            }
                            dateFormat="DD-MM-YYYY"
                            timeFormat="HH:mm:ss"
                        />
                    </div>
                </div>

                {completeDateFlag 
                // && proposalNumber.trim() 
                && (
                    <div className="policy-report__actions">
                        <button
                            type="button"
                            className="policy-report__btn policy-report__btn--primary"
                            onClick={handleApply}
                        >
                            Apply
                        </button>
                    </div>
                )}
            </div>

            {
            data.itemList && data.itemList.length > 0 
            && (
                <>
                    <div className="policy-report__toolbar inline-page-report">
                        <ItemSelect
                            itemsPerPage={recordsPerPage}
                            setItemsPerPage={setMaxRecords}
                        />
                        <ExportExcelButton onClick={downloadReport} />
                    </div>
                    <div className="proposal-dashboard__table-section policy-report__table-section">
                        <DataTable
                            cellHeaders={header}
                            data={data.itemList}
                            keys={key}
                            addSerialNo={true}
                            fileName="Journey selection audit report"
                            showExcelDownload={false}
                            PerPageApiData={true}
                            itemsPerPage={recordsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={selectPage}
                            alwaysShown={false}
                            paginationItems={data}
                            convertValueToString={true}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default AuditTrailReport;
